import type { StationDetail, StationGroupDetail } from '../../api/models/bff/Geography';

type RawStationDetail = SnakeToCamel<StationDetail>;
type RawStationGroupDetail = SnakeToCamel<StationGroupDetail>;

function createRawStationDetail(overrides?: Partial<RawStationDetail>): RawStationDetail {
  return {
    code: 'BCN',
    name: 'Barcelona-El Prat Josep Tarradellas Airport',
    city: 'Barcelona',
    country: 'ES',
    ...overrides,
  };
}

export function createMockStationGroupDetail(overrides?: Partial<RawStationGroupDetail>): RawStationGroupDetail {
  return {
    code: 'ESP',
    name: 'SPAIN_ALL_AIRPORTS',
    country: 'ES',
    display_order: 1,
    stations: [
      createRawStationDetail({ code: 'BCN', name: 'Barcelona-El Prat Josep Tarradellas Airport', city: 'Barcelona', country: 'ES' }),
      createRawStationDetail({ code: 'GRO', name: 'Girona–Costa Brava Airport', city: 'Girona', country: 'ES' }),
      createRawStationDetail({ code: 'MAD', name: 'Adolfo Suárez Madrid–Barajas Airport', city: 'Madrid', country: 'ES' }),
      createRawStationDetail({ code: 'GRX', name: 'Federico García Lorca Granada–Jaén Airport', city: 'Granada', country: 'ES' }),
      createRawStationDetail({ code: 'ZAZ', name: 'Zaragoza Airport', city: 'Zaragoza', country: 'ES' }),
      createRawStationDetail({ code: 'OVD', name: 'Asturias Airport', city: 'Oviedo', country: 'ES' }),
    ],
    ...overrides,
  };
}

export function createMockStationGroupsList(overrides?: Array<Partial<RawStationGroupDetail>>): RawStationGroupDetail[] {
  return overrides
    ? overrides.map(override => createMockStationGroupDetail(override))
    : [createMockStationGroupDetail()];
}
